import { useEffect } from 'react';

const useContentProtection = () => {
  useEffect(() => {
    // ── Disable right-click context menu ──────────────────────────────
    const blockContextMenu = (e: MouseEvent) => e.preventDefault();

    // ── Block copy / cut / paste keyboard shortcuts ───────────────────
    const blockClipboard = (e: KeyboardEvent) => {
      const key = e.key.toLowerCase();
      if (e.ctrlKey || e.metaKey) {
        // c = copy, x = cut, u = view-source, s = save, a = select-all
        // p = print, shift+i / F12 = devtools
        if (['c', 'x', 'u', 's', 'a', 'p'].includes(key)) {
          e.preventDefault();
          return false;
        }
        // Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C (DevTools)
        if (e.shiftKey && ['i', 'j', 'c'].includes(key)) {
          e.preventDefault();
          return false;
        }
      }
      // F12 – DevTools
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
    };

    // ── Block copy / cut events fired by the browser ──────────────────
    const blockCopyEvent = (e: ClipboardEvent) => e.preventDefault();

    // ── Disable drag-start on images and text ─────────────────────────
    const blockDragStart = (e: DragEvent) => e.preventDefault();

    // ── Detect DevTools open via window size heuristic ────────────────
    const devToolsCheck = () => {
      const threshold = 160;
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        // Blur the page content when DevTools is open
        document.body.style.filter = 'blur(8px)';
      } else {
        document.body.style.filter = '';
      }
    };

    document.addEventListener('contextmenu', blockContextMenu);
    document.addEventListener('keydown', blockClipboard);
    document.addEventListener('copy', blockCopyEvent);
    document.addEventListener('cut', blockCopyEvent);
    document.addEventListener('dragstart', blockDragStart);
    window.addEventListener('resize', devToolsCheck);

    return () => {
      document.removeEventListener('contextmenu', blockContextMenu);
      document.removeEventListener('keydown', blockClipboard);
      document.removeEventListener('copy', blockCopyEvent);
      document.removeEventListener('cut', blockCopyEvent);
      document.removeEventListener('dragstart', blockDragStart);
      window.removeEventListener('resize', devToolsCheck);
      document.body.style.filter = '';
    };
  }, []);
};

export default useContentProtection;
